import { useCallback } from 'react';
import type { LoginError as LoginErrorType } from '../../types/login';
import { LoginError } from '../../errorHandlers';

interface CreateResponse {
  errors: LoginErrorType[];
}

export interface Attribute {
  attribute_id: number;
  attribute_value: string;
}

export interface Authentication {
  force_password_reset: false;
  new_password: string;
}

export interface CreateBody {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  attributes?: Attribute[];
  authentication: Authentication;
  recaptchaToken?: string | null;
}

export const createFetcher = async ({
  email,
  first_name,
  last_name,
  phone,
  attributes,
  authentication,
  recaptchaToken,
}: CreateBody): Promise<CreateResponse> => {
  if (!(email && first_name && last_name)) {
    throw new LoginError([
      {
        message: '',
        code: '',
      },
    ]);
  }

  const createResponse = await fetch('/api/signup', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      first_name,
      last_name,
      phone,
      attributes,
      authentication,
      recaptchaToken,
    }),
  });

  const { errors, data } = await createResponse.json();
  if (createResponse.status !== 200) {
    throw new LoginError(errors);
  }

  return data;
};

const useCreate = () =>
  useCallback(async (body: CreateBody) => {
    const data = await createFetcher(body);
    return data;
  }, []);

export default useCreate;
